import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';
import { ArrowUpRight } from 'lucide-react';
import { PushButton } from './PushButton';

export default function DiarioSection() {
  const [posts, setPosts] = useState([]);
  const [cfg, setCfg] = useState({ blog_url: '' });

  useEffect(() => {
    api.get('/blog/posts?limit=3').then(r => setPosts(r.data)).catch(() => setPosts([]));
    api.get('/blog/config').then(r => setCfg(r.data)).catch(() => {});
  }, []);

  if (posts.length === 0) return null;

  const fmtDate = (d) => {
    try { return new Date(d).toLocaleDateString('es-ES', { day: '2-digit', month: 'long', year: 'numeric' }); } catch { return ''; }
  };

  return (
    <section className="mt-32 lg:mt-40 max-w-[1400px] mx-auto px-6 lg:px-12" data-testid="diario-section">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end mb-12">
        <div className="md:col-span-7">
          <p className="overline">Diario</p>
          <h2 className="font-serif text-5xl lg:text-6xl mt-4 leading-[1.05] font-light">
            Lecturas <em className="italic font-light">de estudio.</em>
          </h2>
        </div>
        <div className="md:col-span-5">
          <p className="text-stilo-ink2 leading-relaxed">Ideas, materiales, proyectos y reflexiones que escribo desde el estudio.</p>
          {cfg.blog_url && (
            <a href={cfg.blog_url} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 mt-6 text-sm tracking-[0.22em] uppercase border-b border-stilo-ink hover:text-stilo-gold hover:border-stilo-gold transition-colors pb-1"
              data-testid="diario-all">
              Ver todas las entradas <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
            </a>
          )}
          <PushButton className="mt-6" testid="diario-push-toggle" />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-x-6 gap-y-12">
        {posts.map((p, i) => (
          <a key={p.id} href={p.link} target="_blank" rel="noreferrer" className="group" data-testid={`diario-post-${i}`}>
            <div className="relative bg-stilo-stone aspect-[4/5] overflow-hidden">
              {p.image
                ? <img src={p.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-[1.04]" />
                : <div className="w-full h-full bg-stilo-beige" />}
            </div>
            <p className="overline mt-5 text-stilo-ink3">{fmtDate(p.date)}</p>
            <h3 className="font-serif text-2xl mt-3 leading-tight group-hover:text-stilo-gold transition-colors">{p.title}</h3>
            <span className="inline-flex items-center gap-1 mt-4 text-xs tracking-[0.22em] uppercase text-stilo-ink2 group-hover:text-stilo-gold">
              Leer en el blog <ArrowUpRight className="w-3.5 h-3.5" strokeWidth={1.5} />
            </span>
          </a>
        ))}
      </div>
    </section>
  );
}
